import React from 'react';
import PropTypes from 'prop-types';
import { EpicGamesToggle, PropertyLogo, SiteNav, RightNav, DividerLine, EuCookieMessage, Alert } from './components';
import NavStore from './stores';
import debounce from 'lodash.debounce';
import clone from 'lodash.clone';
import { defaultMessages, properties } from './constants';
import { getPropertyObject, getPropertyName } from './utils/epicPropertyInspector';
import { connectToStores } from 'epic-alt-utils/index';
import { setDataAttribute, getWindowWidth, getWindowHeight } from 'epic-common/src/browser';
import { updateDimensions } from './utils/resizeUtils';
import browser from 'bowser';
import root from 'window-or-global';
import NavActions from './actions';
import Cookies from 'universal-cookie';

//no sass include since its taken care of in another bundle

const versionJson = require('../../version.json');

if (!root._epicGamesNav) {
    root._epicGamesNav = {};
}
root._epicGamesNav.browser = browser;

let cookiesEnabled = false;
if ((root.navigator && root.navigator.cookieEnabled && document && document.cookie !== undefined) || root.__server_side_render) {
    cookiesEnabled = true;
}

@connectToStores
export default class EpicGamesNav extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMobile: false, //is mobile mode with hamburger on top right
            isTablet: false, //is tablet mode with hamburger
            isDesktop: true, // is desktop mode
            collapsedDesktop: false, // cant fit the links in desktop mode
            resizing: false, //currently performing a resize
            init: false
        };

        this.warnedSearch = false;

        this.userAgentSet = false;

        this.lastWidth = null;
        this.lastHeight = null;
        this.scrollY = 0;

        this.localeStringOnBody = '';
        this.cache = {};
        this.dimensionsInitialized = false;
        this.needWidthReCalc = false;
        this.cookies = null;

        this.updateDimensionsDebounce = debounce(updateDimensions, 25);

        this.updateDimensionsOnResize = () => {
            const height = getWindowHeight();
            const width = getWindowWidth();
            if (height === this.lastHeight && width === this.lastWidth) {
                if (process.env.NODE_ENV !== 'production') {
                    console.debug('[EGH] resize event skipped. No window size change detected');
                }
                return null; //browser window didn't actually resize
            }
            this.lastWidth = width;
            this.lastHeight = height;

            this.calcDimensions();
            if (this.props.navStore.searchActive && this.state.isMobile) return null; //keyboard opened on mobile... skip state resizing
            return true;
        };

        this.onScroll = () => {
            this.scrollY = root.scrollY;
        };

        this.onScrollDebouce = debounce(this.onScroll, 50);
    }

    static propTypes = {
        epicPropertyName: PropTypes.string,
        epicPropertyClasses: PropTypes.string,
        navStore: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        links: PropTypes.array,
        hideLocale: PropTypes.bool,
        hideSearch: PropTypes.bool,
        hideSignIn: PropTypes.bool,
        downloadLink: PropTypes.object,
        hideCallToAction: PropTypes.bool,
        hideShieldDownload: PropTypes.bool,
        hideShieldDropdown: PropTypes.bool,
        callToAction: PropTypes.object,
        localeOptions: PropTypes.array,
        logoLink: PropTypes.object,
        displayName: PropTypes.string,
        locale: PropTypes.string,
        accountLinks: PropTypes.object,
        messages: PropTypes.object,
        properties: PropTypes.array,
        onSearch: PropTypes.func,
        pcDownloadUrl: PropTypes.string,
        macDownloadUrl: PropTypes.string,
        isEu: PropTypes.bool,
        euCookie: PropTypes.object,
        globalLinkOnClick: PropTypes.func,
        alert: PropTypes.object,
        cookies: PropTypes.object
    };

    static getStores() {
        return [NavStore];
    }

    static getPropsFromStores() {
        return {
            navStore: NavStore.getState()
        };
    }

    static childContextTypes = {
        isMobile: PropTypes.bool,
        isTablet: PropTypes.bool,
        collapsedDesktop: PropTypes.bool,
        isDesktop: PropTypes.bool,
        messages: PropTypes.object,
        globalLinkOnClick: PropTypes.func
    };

    getCookies() {
        if (this.props.cookies && typeof this.props.cookies === 'object') {
            return this.props.cookies;
        }

        if (!this.cookies) {
            try {
                this.cookies = new Cookies();
            } catch (e) {
                this.cookies = {get: () => {}, set: () => {}};
            }
        }

        return this.cookies;
    }

    componentWillMount() {
        const cookies = this.getCookies();
        if (cookies) {
            root._epicGamesNav.cookies = cookies;

            let euCookieAccepted = false;
            if (cookiesEnabled) {
                const euCookieAcceptedCookie = cookies.get('euCookieAccepted');
                euCookieAccepted = euCookieAcceptedCookie === 'true';
            }
            NavActions.setEuCookieAccepted.defer(euCookieAccepted);
        }
    }

    componentDidMount() {
        this.setLocaleClassOnBody(this.props);
        this.setUserAgent();
        this.checkAlert(this.props);

        root.addEventListener('resize', this.updateDimensionsOnResize);
        root.addEventListener('scroll', this.onScrollDebouce);

        //allow external sites to apply logic when the header is rendered
        if (typeof root._egNavReadyCallback === 'function') {
            root._egNavReadyCallback();
            root._egNavReadyCallbackRun = true;
        } else {
            //start loop in case callback is created late
            let readyChecks = 0;
            const readyCheck = setInterval(() => {
                try {
                    readyChecks++;
                    if (root && root._egNavReadyCallback && typeof root._egNavReadyCallback === 'function') {
                        root._egNavReadyCallback();
                        root._egNavReadyCallbackRun = true;
                        clearInterval(readyCheck);
                    }
                    if (readyChecks > 10) {
                        clearInterval(readyCheck);
                    }
                } catch (e) {
                    clearInterval(readyCheck);
                }
            }, 500);
        }
        root._egNavReadyCallbackCalled = true;

        //Give some time for the css to be applied otherwise the measurements could be off
        setTimeout(() => {
            this.dimensionsInitialized = true;
            this.calcDimensions();
        }, 10);
    }

    componentWillUnmount() {
        root.removeEventListener('resize', this.updateDimensionsOnResize);
        root.removeEventListener('scroll', this.onScrollDebouce);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.localeStringOnBody || this.props.locale !== nextProps.locale) {
            this.setLocaleClassOnBody(nextProps);
        }

        if (this.dimensionsInitialized &&
            this.props.links && nextProps.links &&
            (this.props.links.length !== nextProps.links.length ||
            this.props.epicPropertyName !== nextProps.epicPropertyName)) {
            //may need to check sizes again
            this.needWidthReCalc = true;
        }

        if (!this.props.alert && nextProps.alert) {
            this.checkAlert(nextProps);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (!this.state.init && nextState.init) {
            //may need to check sizes again
            this.needWidthReCalc = true;
        }
    }

    componentDidUpdate() {
        if (this.needWidthReCalc) {
            this.calcDimensions();
        }
    }

    getChildContext() {
        return {
            isMobile: this.state.isMobile,
            isTablet: this.state.isTablet,
            isDesktop: this.state.isDesktop,
            collapsedDesktop: this.state.collapsedDesktop,
            messages: this.getMessages(),
            globalLinkOnClick: this.props.globalLinkOnClick
        };
    }

    checkAlert(props) {
        const alert = props.alert || {};
        const cookies = this.getCookies();

        if (alert.id && cookiesEnabled) {
            const dismissed = !!cookies.get(`egh-alert-${alert.id}`);
            if (!dismissed) {
                NavActions.alertActive.defer(true);
            }
        }
    }

    calcDimensions() {
        if (!this.state || this.state.resizing) return;
        if (!this.resizing) this.setState({ resizing: true });

        const end = () => {
            this.setState({ resizing: false });
        };

        this.updateDimensionsDebounce(this.state, ({ isMobile, isTablet, isDesktop, collapsedDesktop, needWidthReCalc }) => {
            this.setState({
                isMobile,
                isTablet,
                isDesktop,
                collapsedDesktop,
                init: true
            });
            this.needWidthReCalc = needWidthReCalc;
            end();
        }, () => {
            if (!this.state.init) {
                this.setState({ init: true });
            }
            end();
        });
        this.needWidthReCalc = false;
    }

    setUserAgent() {
        const body = document.body;
        if (!this.userAgentSet) {
            this.userAgentSet = true;

            for (const key in browser) {
                if (typeof key === 'string' && typeof browser[key] !== 'function' && key.length > 1 &&
                    key !== 'name' && key !== 'version') {
                    setDataAttribute(body, key, true);
                }
            }

            setDataAttribute(body, 'browserVersion', browser.version);
        }
    }

    setLocaleClassOnBody(props) {
        const locale = (props.locale || '').replace(/-/, '_');
        const regExString = `/${locale}/`;
        const reg = new RegExp(regExString);
        if (typeof document.body !== 'undefined' && typeof document.body.className !== 'undefined' && !reg.test(document.body.className)) {
            if (this.localeStringOnBody && locale !== this.localeStringOnBody) {
                //remove the previous locale
                document.body.className = document.body.className.replace(this.localeStringOnBody, '').replace(/[\s]+/g, ' ');
                this.localeStringOnBody = locale;
                if (document.body.className.length) {
                    document.body.className += ` ${locale}`;
                } else {
                    document.body.className += locale;
                }
            } else if (this.localeStringOnBody && locale === this.localeStringOnBody) {
                //current string is fine
            } else {
                this.localeStringOnBody = locale;
                if (document.body.className.length) {
                    document.body.className += ` ${locale}`;
                } else {
                    document.body.className += locale;
                }
            }
        }
    }

    /**
     * Merges the default messages with the props passed into the component if any. Will cache the result to make
     * future renders much faster rather than merging every time.
     *
     * Checks the props for valid message constants otherwise returns the default values
     */
    getMessages() {
        let m = {};

        //check cache to see if props have not changed and skip the iteration
        if (this.props.messages && this.props.messages.asMutable && this.props.messages === this.cache.messages) {
            m = this.cache.m;
        } else {
            if (this.props.messages) {
                for (const key in defaultMessages) {
                    if (typeof key === 'string' && this.props.messages[key] && this.props.messages[key].length) {
                        m[key] = this.props.messages[key];
                    } else {
                        m[key] = defaultMessages[key];
                    }
                }
            } else {
                m = defaultMessages;
            }

            this.cache.messages = this.props.messages;
            this.cache.m = m;
        }
        return m;
    }

    /**
     * Merges the default properties with the props passed into the component if any. Will cache the result to make
     * future renders much faster rather than merging every time.
     *
     * NOTE: properties refers to the epic games properties to be listed under the epic shield
     * @return {array} Array of epic properties for the sheild
     */
    getProperties() {
        let p = [];
        if (this.props.properties && this.props.properties.asMutable && this.props.properties === this.cache.properties) {
            p = this.cache.p;
        } else {
            for (const key in properties) {
                if (typeof key === 'string') {
                    const egDefaultProp = properties[key];
                    egDefaultProp.propertyKey = key;
                    let egProp;

                    if (this.props.properties && this.props.properties.length > 0) {
                        this.props.properties.forEach((prop) => {
                            if (prop.propertyKey === key) {
                                egProp = prop;
                                return false;
                            }
                            return undefined;
                        });
                    }
                    if (egProp) {
                        const mergedProp = clone(egDefaultProp);
                        //check inside of the object
                        for (const field in egProp) {
                            if (typeof field === 'string') {
                                if (typeof egProp[field] !== 'undefined') {
                                    mergedProp[field] = egProp[field];
                                } else {
                                    mergedProp[field] = egDefaultProp[field];
                                }
                            }
                        }
                        p.push(mergedProp);
                    } else {
                        p.push(egDefaultProp);
                    }
                }
            }
            this.cache.properties = this.props.properties;
            this.cache.p = p;
        }
        return p;
    }

    render() {
        const epicPropertyName = getPropertyName(this.props.epicPropertyName);
        const epicPropertyConfig = getPropertyObject(epicPropertyName);
        const epicPropertyClasses = this.props.epicPropertyClasses || '';
        const links = this.props.links;
        const epicProperties = this.getProperties();
        if (!epicPropertyConfig || !links) {
            console.error('[EGH] Failed to initialize properly! Missing a valid epicPropertyConfig or links key!');
        }

        let horizontalSiteNav;
        if (!this.state.isMobile) {
            horizontalSiteNav = (
                <SiteNav
                    links={links}
                    showLinks={this.props.navStore.tabletNavActive}
                    mobileActiveLinkIndex={this.props.navStore.mobileActiveLinkIndex}
                    searchActive={this.props.navStore.searchActive} />
            );
        }

        const menuOpen = this.props.navStore.mobileNavActive || this.props.navStore.tabletNavActive || this.props.navStore.egNavActive ? 'menu-open' : '';
        const posFixed = this.scrollY && this.scrollY > 52 ? 'pos-fixed' : '';

        const navResponsiveClasses = `${this.state.isTablet ? 'tablet' : ''} ${this.state.isDesktop ?
            'desktop' : ''} ${this.state.isMobile ? 'mobile' : ''}`;

        let hideSearch = this.props.hideSearch;
        if (!hideSearch && !this.props.onSearch) {
            hideSearch = true;
            if (!this.warnedSearch) {
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('[EGH] hideSearch is false but no onSearch callback is specified. Search capabilities cannot be displayed.');
                }
                this.warnedSearch = true;
            }
        }

        let hideTabletHamburger = false;
        if (links && links.length === 0) {
            hideTabletHamburger = true;
        }

        const navStore = this.props.navStore || {};
        const cookies = this.getCookies();
        const alert = this.props.alert || {};
        const showAlert = alert && alert.msg;
        const alertActive = navStore.alertActive;
        const addAlertClass = alertActive && showAlert;

        const resizing = this.state.resizing ? 'resizing' : '';
        const init = this.state.init ? 'init' : '';

        return (
            <header
                id="egh"
                className={`${epicPropertyName} ${epicPropertyClasses} ${resizing} ${init} ${menuOpen} ${posFixed} ${addAlertClass ? 'alert-active' : ''}`}
                data-version={versionJson.version || ''}>
                {this.props.isEu &&
                <EuCookieMessage
                    isEu={this.props.isEu}
                    isAccepted={navStore.euCookieAccepted}
                    config={this.props.euCookie}
                    cookies={cookies} />
                }
                {showAlert ? <Alert type={alert.type} statusHref={alert.statusHref} msg={alert.msg} id={alert.id} hidden={alert.hidden} cookies={cookies} /> : ''}
                <nav
                    id="nav"
                    className={`${menuOpen} ${posFixed} ${navResponsiveClasses} ${addAlertClass ? 'alert-active' : 'no-alert'}`}>
                    <div>
                        <div
                            id="propNav">
                            <EpicGamesToggle
                                isActive={navStore.egNavActive}
                                epicPropertyName={epicPropertyName}
                                epicPropertyConfig={epicPropertyConfig}
                                properties={epicProperties}
                                downloadLink={this.props.downloadLink}
                                pcDownloadUrl={this.props.pcDownloadUrl}
                                macDownloadUrl={this.props.macDownloadUrl}
                                searchActive={navStore.searchActive}
                                hideShieldDownload={this.props.hideShieldDownload}
                                hideShieldDropdown={this.props.hideShieldDropdown} />
                            <PropertyLogo
                                logoLink={this.props.logoLink}
                                searchActive={navStore.searchActive} />
                            <DividerLine
                                hideTabletHamburger={hideTabletHamburger}
                                isActive={navStore.tabletNavActive}
                                searchActive={navStore.searchActive} />
                            {horizontalSiteNav}
                        </div>
                        <RightNav
                            searchActive={navStore.searchActive}
                            isLoggedIn={this.props.isLoggedIn}
                            hideLocale={this.props.hideLocale}
                            hideSearch={hideSearch}
                            hideSignIn={this.props.hideSignIn}
                            hideCallToAction={this.props.hideCallToAction}
                            callToAction={this.props.callToAction}
                            links={links}
                            isActive={navStore.mobileNavActive}
                            localeOptions={this.props.localeOptions}
                            showLinks={navStore.mobileNavActiveLinks}
                            mobileUserActive={navStore.mobileUserActive}
                            mobileActiveLinkIndex={navStore.mobileActiveLinkIndex}
                            mobileLocaleActive={navStore.mobileLocaleActive}
                            locale={this.props.locale}
                            displayName={this.props.displayName}
                            accountLinks={this.props.accountLinks}
                            onSearch={this.props.onSearch}
                            maxWidth={this.maxRightNavWidth} />
                    </div>
                </nav>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/EpicGamesNav.js